/* KieroKombucha — página de producto (Sesión 2). JS mínimo, sin frameworks:
   1) swap de galería (miniatura -> imagen principal)
   2) selección de variante (cuando el producto tiene más de una opción) */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // --- Galería ---
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (main) {
            main.src = thumb.getAttribute('data-full');
            main.srcset = '';
          }
        });
      });
    });

    // --- Stepper de cantidad (independiente del carrito, solo para el form de agregar) ---
    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var dec = stepper.querySelector('[data-qty-decrease]');
      var inc = stepper.querySelector('[data-qty-increase]');
      if (!input) return;
      if (dec) dec.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (inc) inc.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    // --- Selector de variantes ---
    document.querySelectorAll('[data-product-form]').forEach(function (formEl) {
      var dataEl = formEl.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var optionSelects = formEl.querySelectorAll('[data-option-select]');
      var variantIdInput = formEl.querySelector('[data-variant-id]');
      var priceNow = formEl.querySelector('[data-price-now]');
      var priceCompare = formEl.querySelector('[data-price-compare]');
      var availEl = formEl.querySelector('[data-availability]');
      var addBtn = formEl.querySelector('[data-add-button]');

      function moneyFormat(cents) {
        return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      function findVariant() {
        var selected = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function updateUI() {
        var variant = findVariant();
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceNow) priceNow.textContent = moneyFormat(variant.price);
        if (priceCompare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompare.textContent = moneyFormat(variant.compare_at_price);
            priceCompare.style.display = '';
          } else {
            priceCompare.style.display = 'none';
          }
        }
        if (availEl) {
          if (variant.available) {
            availEl.textContent = 'En stock';
            availEl.classList.remove('out');
            availEl.classList.add('in-stock');
          } else {
            availEl.textContent = 'Agotado';
            availEl.classList.remove('in-stock');
            availEl.classList.add('out');
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
        }
      }

      optionSelects.forEach(function (select) {
        select.addEventListener('change', updateUI);
      });
    });
  });
})();
